<template>
    <div
        class="space-x-1 p-1 rounded text-xs font-semibold w-max h-max"
        :class="bgClass[tipo]"
        :title="title"
    >
        <div class="flex space-x-1" :class="flexCol ? 'flex-col' : 'flex-row'">
            <span
                class="space-x-2"
                :class="valor ? 'text-stone-200 dark:text-slate-50' : ''"
            >
                <font-awesome-icon
                    v-if="icon"
                    :icon="icon"
                    :class="iconClass[tipo]"
                 />
                <span>{{ label }}</span></span
            >
            <span
                v-if="valor"
                :class="valor ? 'text-white dark:text-slate-200' : ''"
                >{{ valor }}</span
            >
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: "",
    },
    label: {
        type: String,
        default: "",
    },
    valor: {
        type: String,
        default: "",
    },

    icon: {
        type: String,
        default: "",
    },
    tipo: {
        type: String,
        default: "neutro",
    },
    flexCol: {
        type: Boolean,
        default: false,
    },
});

const bgClass = {
    neutro: "bg-stone-500 dark:bg-gray-600 text-slate-200",
    transparent: "text-slate-200",
    red: "bg-red-500 dark:bg-red-700 dark:text-slate-200",
    lime: "bg-lime-500 dark:bg-lime-600 dark:text-slate-200",
};

const iconClass = {
    neutro: "text-slate-200",
    red: "text-red-800 dark:text-red-400",
    lime: "text-lime-700 dark:text-lime-400",
    transparent: "text-slate-200",
};
</script>
